// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1DOa_","file":"styles_file__3jxEr"};